///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class Password {
    constructor(private readonly http: HttpClient) {}

    save(newPassword: string): Observable<unknown> {
        return this.http.post('api/account/change_password', newPassword);
    }
}
